module.exports = __webpack_public_path__ + "static/img/alipaylogo.1d579784.svg";